import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Upload, FileText, UserRound } from "lucide-react";
import { useDossierStore } from "../../store/dossierStore";

const navClass = ({ isActive }: { isActive: boolean }) =>
  `flex flex-1 flex-col items-center gap-1 py-2 text-[11px] font-semibold transition-colors ${
    isActive ? "text-orange-600" : "text-slate-500"
  }`;

export default function MobileLayout() {
  const navigate = useNavigate();
  const activeDossier = useDossierStore((s) => s.activeDossier);

  return (
    <div className="flex min-h-[100dvh] flex-col bg-gradient-to-b from-orange-50 via-orange-50/90 to-amber-50/80">
      <header
        className="safe-area-inset shrink-0 border-b border-orange-200/70 bg-white/95 backdrop-blur-sm"
        style={{
          paddingTop: "max(env(safe-area-inset-top, 0px), 8px)",
        }}
      >
        <div className="flex items-center justify-between gap-3 px-4 pb-3 pt-1">
          <span className="text-xl font-extrabold tracking-tight text-orange-600">Woahda</span>
          <button
            type="button"
            onClick={() => navigate("/mobile/dossier")}
            className="max-w-[55%] truncate rounded-lg border border-orange-200 bg-orange-50/80 px-3 py-2 text-left text-[15px] font-semibold text-orange-900"
          >
            {activeDossier?.nom ?? "Choisir un dossier"}
          </button>
        </div>
      </header>

      <main className="min-h-0 flex-1 overflow-y-auto px-4 py-4 pb-[calc(5.5rem+env(safe-area-inset-bottom,0px))]">
        <Outlet />
      </main>

      <nav
        className="fixed bottom-0 left-0 right-0 z-40 border-t border-orange-200/80 bg-white/95 shadow-[0_-4px_20px_rgba(0,0,0,0.06)] backdrop-blur-md"
        style={{ paddingBottom: "max(env(safe-area-inset-bottom, 0px), 8px)" }}
      >
        <div className="flex max-w-lg mx-auto">
          <NavLink to="/mobile/dashboard" className={navClass} end>
            <LayoutDashboard className="h-6 w-6" strokeWidth={2} />
            Dashboard
          </NavLink>
          <NavLink to="/mobile/import" className={navClass}>
            <Upload className="h-6 w-6" strokeWidth={2} />
            Import
          </NavLink>
          <NavLink to="/mobile/factures" className={navClass}>
            <FileText className="h-6 w-6" strokeWidth={2} />
            Factures
          </NavLink>
          <NavLink to="/mobile/profil" className={navClass}>
            <UserRound className="h-6 w-6" strokeWidth={2} />
            Profil
          </NavLink>
        </div>
      </nav>
    </div>
  );
}
